import withContentfulData from 'components/hoc/withContentfulData';

import FaqCategoryList from './FaqCategoryList';

export default withContentfulData(FaqCategoryList);
